import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAllStatuses } from 'apis/projectProposals.api';

const useGetAllStatus = (t, conds) => {
  const { data: statusesData, ...rest } = useQuery(['projectProposalStatuses'], getAllStatuses, {
    ...conds,
  });
  const statuses = useMemo(
    () =>
      statusesData?.data.map((e) => ({
        id: e.id,
        code: e?.name,
        name: e?.name ? t(`statuses.${e.name}`) : '',
      })) ?? [],
    [statusesData, t]
  );

  return {
    data: statuses,
    ...rest,
  };
};

export default useGetAllStatus;
